var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('p',[_vm._v(_vm._s(_vm.code))]),_c('Transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":"Layout"}},[_c('router-view',{staticClass:"child-view"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }